export default {"src":"/_next/static/media/person.19069353.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};